<template>
    <box :hideable="true" :loading="loading">
        <h3 slot="header">
            <i class="fas fa-sign-out-alt"></i> Result
        </h3>
        <div slot="body">
            <pre v-html="jsonHtml">

            </pre>
        </div>
    </box>
</template>

<script>

import BootStrapBox from '../../../Components/Util/BootstrapBox.vue';

export default {
    name: 'operator-test-output',
    components: {
        'Box': BootStrapBox
    },
    methods: {
        //https://stackoverflow.com/questions/4810841/how-can-i-pretty-print-json-using-javascript
        highlightSyntax(json) {
            const vm = this;

            json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
                return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
                    var cls = 'number';
                    if (/^"/.test(match)) {
                        if (/:$/.test(match)) {
                            cls = 'key';
                        } else {
                            cls = 'string';
                        }
                    } else if (/true|false/.test(match)) {
                        cls = 'boolean';
                    } else if (/null/.test(match)) {
                        cls = 'null';
                    }
                    return `<span ${vm.$options._scopeId} class="${cls}">${match}</span>`;
                });
        }
    },
    computed: {
        jsonString() {
            return JSON.stringify(
                this.value,
                undefined, 
                4
            );
        },
        jsonHtml() {
            //Limit to 10.000 chars to stop the page from getting too slow.
            return this.highlightSyntax(
                this.jsonString.length > 10000 
                    ? this.jsonString.substring(0,10000) + '...' 
                    : this.jsonString
            );
        }
    },
    props: {
        value: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        }
    }
};
</script>

<style lang="scss" scoped src="../Style/output.scss">

</style>